import { isLoggedIn } from './authService';
import { API_URL } from '../config/api';

export const getMyQuizResults = async () => {
    if (!isLoggedIn()) return [];
    try {
        const response = await fetch(`${API_URL}/quiz-results/my`, {
            credentials: 'include',
        });
        if (!response.ok) return [];
        return response.json();
    } catch (e) {
        return [];
    }
};

export const getMyQuizResult = async (quizId) => {
    if (!isLoggedIn()) return null;
    try {
        const response = await fetch(`${API_URL}/quiz-results/my/${quizId}`, {
            credentials: 'include',
        });
        if (!response.ok) {
            if (response.status !== 404) {
                console.warn(`[QuizResult] GET /my/${quizId} → HTTP ${response.status}`);
            }
            return null;
        }
        return response.json();
    } catch (e) {
        console.error('[QuizResult] GET error:', e);
        return null;
    }
};

// Saves (or updates) a quiz result. Throws if the save fails so callers can
// display an error to the user instead of silently losing the result.
export const saveQuizResult = async (quizId, correctAnswers, totalQuestions) => {
    if (!isLoggedIn()) return null;

    const body = JSON.stringify({ quizId, correctAnswers, totalQuestions });
    const headers = { 'Content-Type': 'application/json' };

    const postResponse = await fetch(`${API_URL}/quiz-results`, {
        method: 'POST',
        credentials: 'include',
        headers,
        body,
    });

    if (postResponse.ok) return postResponse.json();

    // POST failed — result likely already exists; try PUT
    const putResponse = await fetch(`${API_URL}/quiz-results/${quizId}`, {
        method: 'PUT',
        credentials: 'include',
        headers,
        body,
    });

    if (putResponse.ok) return putResponse.json();

    throw new Error(`Nepodařilo se uložit výsledek kvízu (${putResponse.status})`);
};
